import React, { Fragment } from 'react';
import Call from "../../hocs/call";
import EnhancedModal from "../../components/enhanced-modal";
import { GUTTER_SM, MODAL_WIDTH_MD, MODAL_WIDTH_SM, MODAL_WIDTH_XL } from "../../styles/constants";
import { Alert, Button, Col, Modal, Row } from "antd";
import { compose } from "redux";
import { connect } from "react-redux";
import { translate } from 'react-i18next';
import {
  changeDsdDetail,
  changeDsdDetailClone,
  changeDsdDetailDownload,
  changeDsdDetailDsdExport,
  changeDsdDetailPrimaryMeasure,
  createDsdDetailAttribute,
  createDsdDetailDimension,
  createDsdDetailGroup,
  deleteDsdDetailAttribute,
  deleteDsdDetailDimension,
  deleteDsdDetailGroup,
  editDsdDetailAttribute,
  editDsdDetailDimension,
  editDsdDetailGroup,
  hideDsdDetail,
  hideDsdDetailClone,
  hideDsdDetailDownload,
  hideDsdDetailDsdExport,
  hideDsdDetailDsdExportReport,
  readDsdDetail,
  readDsdDetailAgencies,
  readDsdDetailCodelists,
  readDsdDetailConceptSchemes,
  readDsdDetailHierarchicalCodelists,
  showDsdDetailClone,
  showDsdDetailCodelistsForSelector,
  showDsdDetailConceptSchemesForSelector,
  showDsdDetailDownload,
  showDsdDetailDsdExport,
  submitDsdDetailClone,
  submitDsdDetailCreate,
  submitDsdDetailDownload,
  submitDsdDetailDsdExport,
  submitDsdDetailUpdate
} from "./actions";
import DsdDetail from "./dsd-detail";
import {
  ARTEFACT_FORM_MODE_CREATE,
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from "../../components/artefact-form";
import ArtefactCloneForm from "../../components/artefact-clone-form";
import DsdsCodelistSelector from "./artefact-selectors/CodelistSelector";
import DsdsConceptSchemeSelector from "./artefact-selectors/ConceptSchemeSelector";
import DsdsConceptSelector from "./artefact-selectors/ConceptSelector";
import DsdsDimensionDetail from "./component-details/DimensionDetail";
import DsdsGroupDetail from "./component-details/GroupDetail";
import DsdsAttributeDetail from "./component-details/AttributeDetail";
import { DSD_DIMENSION_TYPE_NORMAL, getStringFromArtefactTriplet } from "../../utils/sdmxJson";
import {
  isArtefactValid,
  isCloneDestTripletValid,
  isExportDestinationValid
} from "../../utils/artefactValidators";
import { reuseAction } from "../../utils/reduxReuse";
import ArtefactExportReport from "../../components/artefact-export-report";
import ArtefactExportForm from "../../components/artefact-export-form";
import {
  DSD_DETAIL_CODELIST_DETAIL_PREFIX,
  DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX
} from "./reducer";
import ReduxCodelistDetailModal from "../redux-codelist-detail-modal";
import { editCodelistDetail } from "../redux-codelist-detail-modal/actions";
import { editConceptSchemeDetail } from "../redux-concept-scheme-detail-modal/actions";
import ReduxConceptSchemeDetailModal from "../redux-concept-scheme-detail-modal";
import { DataLanguageConsumer } from "../../contexts/DataLanguage";
import ArtefactDownloadForm from "../../components/artefact-download-form";
import {
  ARTEFACT_TYPE_DSD,
  ARTEFACT_TYPE_MULTIPLE,
  getArtefactDownloadOptions
} from "../../constants/download";
import DsdsNotDisplayedCodesSelector from "./artefact-selectors/NotDisplayedCodesSelector";
import DsdsDefaultCodesSelector from "./artefact-selectors/DefaultCodesSelector";
import DsdsHierarchicalCodelistSelector from "./artefact-selectors/HierarchicalCodelistSelector";
import { setHclReferenceAnnotation } from '../../utils/annotations';

const mapStateToProps = (state, { instanceState }) => ({
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  permissions: state.app.user.permissions,
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  isVisible: instanceState.isVisible,
  isAgenciesValid: instanceState.isAgenciesValid,
  dsd: instanceState.dsd,
  dsdTriplet: instanceState.dsdTriplet,
  isEditDisabled: instanceState.isEditDisabled,
  agencies: instanceState.agencies,
  allAgencies: instanceState.allAgencies,
  cloneDestTriplet: instanceState.cloneDestTriplet,
  downloadDsdTriplets: instanceState.downloadDsdTriplets,
  downloadDsdLang: instanceState.downloadDsdLang,
  downloadDsdParams: instanceState.downloadDsdParams,
  dsdExportSourceTriplet: instanceState.dsdExportSourceTriplet,
  dsdExportDestination: instanceState.dsdExportDestination,
  dsdExportReport: instanceState.dsdExportReport,
  codelistDetail: instanceState.codelistDetail,
  conceptSchemeDetail: instanceState.conceptSchemeDetail,
  codelists: instanceState.codelists,
  conceptSchemes: instanceState.conceptSchemes,
  hierarchicalCodelists: instanceState.hierarchicalCodelists
});

const mapDispatchToProps = (dispatch, { instancePrefix }) => ({
  onHide: () => dispatch(reuseAction(hideDsdDetail(), instancePrefix)),
  onDimensionCreate: () => dispatch(reuseAction(createDsdDetailDimension(), instancePrefix)),
  onDimensionDetail: id => dispatch(reuseAction(editDsdDetailDimension(id), instancePrefix)),
  onDimensionDelete: id => dispatch(reuseAction(deleteDsdDetailDimension(id), instancePrefix)),
  onGroupCreate: () => dispatch(reuseAction(createDsdDetailGroup(), instancePrefix)),
  onGroupDetail: id => dispatch(reuseAction(editDsdDetailGroup(id), instancePrefix)),
  onGroupDelete: id => dispatch(reuseAction(deleteDsdDetailGroup(id), instancePrefix)),
  onAttributeCreate: () => dispatch(reuseAction(createDsdDetailAttribute(), instancePrefix)),
  onAttributeDetail: id => dispatch(reuseAction(editDsdDetailAttribute(id), instancePrefix)),
  onAttributeDelete: id => dispatch(reuseAction(deleteDsdDetailAttribute(id), instancePrefix)),
  onConceptSchemeDetailEdit: (conceptSchemeTriplet, defaultItemsViewMode) =>
    dispatch(reuseAction(editConceptSchemeDetail(conceptSchemeTriplet, defaultItemsViewMode), instancePrefix + DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX)),
  onCodelistDetailEdit: (codelistTriplet, defaultItemsViewMode) =>
    dispatch(reuseAction(editCodelistDetail(codelistTriplet, defaultItemsViewMode), instancePrefix + DSD_DETAIL_CODELIST_DETAIL_PREFIX)),
  onDownloadShow: (dsdTriplets, lang) => dispatch(reuseAction(showDsdDetailDownload(dsdTriplets, lang), instancePrefix)),
  onDownloadHide: () => dispatch(reuseAction(hideDsdDetailDownload(), instancePrefix)),
  onDownloadChange: fields => dispatch(reuseAction(changeDsdDetailDownload(fields), instancePrefix)),
  onDownloadSubmit: (artefactTriplets, downloadDsdParams, lang) =>
    dispatch(reuseAction(submitDsdDetailDownload(artefactTriplets, downloadDsdParams, lang), instancePrefix)),
  onCloneShow: artefactTriplet => dispatch(reuseAction(showDsdDetailClone(artefactTriplet), instancePrefix)),
  onCloneHide: () => dispatch(reuseAction(hideDsdDetailClone(), instancePrefix)),
  onCloneSubmit: (cloneDestTriplet, srcDsd, annotationsConfig) => dispatch(reuseAction(submitDsdDetailClone(cloneDestTriplet, srcDsd, annotationsConfig), instancePrefix)),
  onCloneChange: fields => dispatch(reuseAction(changeDsdDetailClone(fields), instancePrefix)),
  onConceptSchemesForSelectorShow: () => dispatch(reuseAction(showDsdDetailConceptSchemesForSelector(), instancePrefix)),
  onCodelistsForSelectorShow: () => dispatch(reuseAction(showDsdDetailCodelistsForSelector(), instancePrefix)),
  onPrimaryMeasureChange: fields => dispatch(reuseAction(changeDsdDetailPrimaryMeasure(fields), instancePrefix)),
  onChange: fields => dispatch(reuseAction(changeDsdDetail(fields), instancePrefix)),
  onSubmitCreate: dsd => dispatch(reuseAction(submitDsdDetailCreate(dsd), instancePrefix)),
  onSubmitUpdate: dsd => dispatch(reuseAction(submitDsdDetailUpdate(dsd), instancePrefix)),
  fetchAgencies: allowedAgencies => dispatch(reuseAction(readDsdDetailAgencies(allowedAgencies), instancePrefix)),
  fetchDsd: dsdTriplet => dispatch(reuseAction(readDsdDetail(dsdTriplet), instancePrefix)),
  fetchCodelists: () => dispatch(reuseAction(readDsdDetailCodelists(), instancePrefix)),
  fetchConceptSchemes: () => dispatch(reuseAction(readDsdDetailConceptSchemes(), instancePrefix)),
  onExportShow: sourceTriplet => dispatch(reuseAction(showDsdDetailDsdExport(sourceTriplet), instancePrefix)),
  onExportHide: () => dispatch(reuseAction(hideDsdDetailDsdExport(), instancePrefix)),
  onExportChange: fields => dispatch(reuseAction(changeDsdDetailDsdExport(fields), instancePrefix)),
  onExportSubmit: (sourceTriplet, destination) => dispatch(reuseAction(submitDsdDetailDsdExport(sourceTriplet, destination), instancePrefix)),
  onExportReportHide: () => dispatch(reuseAction(hideDsdDetailDsdExportReport(), instancePrefix)),
  fetchHierarchicalCodelists: () => dispatch(reuseAction(readDsdDetailHierarchicalCodelists(), instancePrefix)),
});

const ReduxDsdDetailModal = ({
  t,
  nodeId,
  nodes,
  permissions,
  appLanguage,
  dataLanguages,
  instanceState,
  instancePrefix,
  isVisible,
  isAgenciesValid,
  dsd,
  dsdTriplet,
  isEditDisabled,
  agencies,
  allAgencies,
  codelistDetail,
  conceptSchemeDetail,
  codelists,
  conceptSchemes,
  hierarchicalCodelists,
  onHide,
  onChange,
  onPrimaryMeasureChange,
  onDimensionDetail,
  onDimensionCreate,
  onDimensionDelete,
  onGroupDetail,
  onGroupCreate,
  onGroupDelete,
  onAttributeDetail,
  onAttributeCreate,
  onAttributeDelete,
  onSubmitCreate,
  onSubmitUpdate,
  onCodelistDetailEdit,
  onConceptSchemeDetailEdit,
  fetchDsd,
  fetchCodelists,
  fetchConceptSchemes,
  fetchAgencies,
  fetchHierarchicalCodelists,
  onCodelistsForSelectorShow,
  onConceptSchemesForSelectorShow,
  downloadDsdTriplets,
  downloadDsdLang,
  downloadDsdParams,
  onDownloadShow,
  onDownloadHide,
  onDownloadChange,
  onDownloadSubmit,
  cloneDestTriplet,
  onCloneShow,
  onCloneHide,
  onCloneSubmit,
  onCloneChange,
  dsdExportSourceTriplet,
  dsdExportDestination,
  dsdExportReport,
  onExportShow,
  onExportHide,
  onExportChange,
  onExportSubmit,
  onExportReportHide
}) => {

  const getRelatedComponentId = id =>
    [
      ...(dsd.groups || []),
      ...(dsd.attributes || [])
    ].find(({ groupDimensions, attachedDimensions, attachmentGroup }) =>
      (groupDimensions || attachedDimensions || (attachmentGroup ? [attachmentGroup] : null) || [])
        .find(compId => compId === id)
    );

  const userHasPermissionsToEdit = (
    permissions && dsdTriplet &&
    permissions.agencies.filter(agency => agency === dsdTriplet.agencyID).length > 0
  );
  const permittedAgencies = permissions ? (allAgencies && Object.fromEntries(Object.entries(allAgencies).filter(([key]) => (permissions.agencies || []).includes(key)))) : {};
  const defaultItemsViewMode = nodes.find(node => node.general.id === nodeId).general.defaultItemsViewMode;
  const annotationsConfig = nodes.find(node => node.general.id === nodeId).annotations;


  return (
    <Fragment>
      <Call cb={fetchCodelists} disabled={!isVisible || codelists !== null}>
        <Call cb={fetchConceptSchemes} disabled={!isVisible || conceptSchemes !== null}>
          <Call cb={fetchHierarchicalCodelists} disabled={!isVisible || hierarchicalCodelists !== null}>
            <DataLanguageConsumer>
              {dataLanguage => {
                const lang = dataLanguage || appLanguage;
                return (
                  <Call
                    cb={fetchDsd}
                    cbParam={dsdTriplet}
                    disabled={dsdTriplet === null || dsd !== null}
                  >
                    <Call
                      cb={fetchAgencies}
                      cbParam={permissions ? permissions.agencies : undefined}
                      disabled={isAgenciesValid}
                    >
                      <EnhancedModal
                        visible={isVisible}
                        width={MODAL_WIDTH_XL}
                        title={
                          dsdTriplet !== null
                            ? ((userHasPermissionsToEdit && !isEditDisabled)
                              ? t('reduxComponents.dsdDetail.title.editMode.title', { triplet: dsdTriplet })
                              : t('reduxComponents.dsdDetail.title.viewMode.title', { triplet: dsdTriplet })
                            )
                            : t('reduxComponents.dsdDetail.title.createMode.title')
                        }
                        onCancel={onHide}
                        footer={
                          <div>
                            <Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>
                            {(dsdTriplet === null || userHasPermissionsToEdit) && !isEditDisabled && (
                              <Button
                                type="primary"
                                onClick={
                                  () => {

                                    if (isArtefactValid(dsd)) {
                                      if (dsd && dsd.primaryMeasure.id && dsd.primaryMeasure.concept &&
                                        dsd.dimensions && dsd.dimensions.length &&
                                        dsd.dimensions.find(({ type }) => type === DSD_DIMENSION_TYPE_NORMAL)) {

                                        const componentsWithHcl = [];
                                        (dsd.dimensions.filter(dim => dim.hclTriplet) || [])
                                          .forEach(dim => componentsWithHcl.push({
                                            id: dim.id,
                                            hclTriplet: dim.hclTriplet,
                                            hierId: dim.hierId
                                          }
                                          ));
                                        ((dsd.attributes || []).filter(attr => attr.hclTriplet) || [])
                                          .forEach(attr => componentsWithHcl.push({
                                            id: attr.id,
                                            hclTriplet: attr.hclTriplet,
                                            hierId: attr.hierId
                                          }
                                          ));
                                        dsd.annotations = setHclReferenceAnnotation(dsd.annotations, annotationsConfig, componentsWithHcl);

                                        return dsdTriplet ? onSubmitUpdate(dsd) : onSubmitCreate(dsd);

                                      } else {

                                        return (
                                          Modal.warning({
                                            title: t('reduxComponents.dsdDetail.modals.warnings.submitIncomplete.title'),
                                            content: t('reduxComponents.dsdDetail.modals.warnings.submitIncomplete.content'),
                                          })
                                        );
                                      }
                                    } else {
                                      Modal.warning({
                                        title: t('commons.alerts.invalidForm.title'),
                                        content: t('commons.alerts.invalidForm.content')
                                      });
                                    }
                                  }
                                }
                              >
                                {t('commons.buttons.save.title')}
                              </Button>
                            )}
                          </div>
                        }
                        withDataLanguageSelector
                      >
                        {dsdTriplet && permissions && !userHasPermissionsToEdit && !isEditDisabled && (
                          <Alert
                            type="warning"
                            showIcon
                            message={t('commons.artefact.alerts.hasNotAgencyPermission')}
                          />
                        )}
                        {dsdTriplet && !isEditDisabled && (
                          <Row type="flex" gutter={GUTTER_SM} justify={"end"}>
                            {onDownloadShow && (
                              <Col>
                                <Button
                                  type="primary"
                                  shape="circle"
                                  icon="download"
                                  size="small"
                                  title={t('commons.artefact.buttons.download.title')}
                                  onClick={() => onDownloadShow([dsdTriplet], lang)}
                                />
                              </Col>
                            )}
                            {permissions && (dsd != null && !dsd.hasOwnProperty('isStructure20')) && (
                              <Col>
                                <Button
                                  type="primary"
                                  shape="circle"
                                  icon="copy"
                                  size="small"
                                  title={t('commons.artefact.buttons.clone.title')}
                                  onClick={() => onCloneShow(dsdTriplet)}
                                />
                              </Col>
                            )}
                            <Col>
                              <Button
                                type="primary"
                                shape="circle"
                                icon="export"
                                size="small"
                                title={t('commons.artefact.buttons.export.title')}
                                onClick={() => onExportShow(dsdTriplet)}
                              />
                            </Col>
                          </Row>
                        )}
                        <DsdDetail
                          dsd={dsd}
                          mode={
                            dsdTriplet === null
                              ? ARTEFACT_FORM_MODE_CREATE
                              : (
                                (userHasPermissionsToEdit && !isEditDisabled)
                                  ? ARTEFACT_FORM_MODE_EDIT
                                  : ARTEFACT_FORM_MODE_READ
                              )
                          }
                          isComponentsDisabled={dsd && dsd.remoteIsFinal}
                          agencies={agencies}
                          onGeneralChange={onChange}
                          onPrimaryMeasureChange={onPrimaryMeasureChange}
                          onDimensionDetail={({ id }) => onDimensionDetail(id)}
                          onDimensionCreate={onDimensionCreate}
                          onDimensionDelete={
                            ({ id }) => Modal.confirm({
                              title: t('reduxComponents.dsdDetail.component.deleteConfirmModal.title', { id }),
                              onOk() {
                                const relatedComponent = getRelatedComponentId(id);
                                relatedComponent
                                  ? Modal.warning({
                                    title: t('reduxComponents.dsdDetail.component.deleteWarningModal.title', { id }),
                                    content: t('reduxComponents.dsdDetail.component.deleteWarningModal.content', {
                                      component: relatedComponent.id
                                    })
                                  })
                                  : onDimensionDelete(id)
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                          onGroupDetail={({ id }) => onGroupDetail(id)}
                          onGroupCreate={onGroupCreate}
                          onGroupDelete={
                            ({ id }) => Modal.confirm({
                              title: t('reduxComponents.dsdDetail.component.deleteConfirmModal.title', { id }),
                              onOk() {
                                const relatedComponent = getRelatedComponentId(id);
                                relatedComponent
                                  ? Modal.warning({
                                    title: t('reduxComponents.dsdDetail.component.deleteWarningModal.title', { id }),
                                    content: t('reduxComponents.dsdDetail.component.deleteWarningModal.content', {
                                      component: relatedComponent.id
                                    })
                                  })
                                  : onGroupDelete(id)
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                          onAttributeDetail={({ id }) => onAttributeDetail(id)}
                          onAttributeCreate={onAttributeCreate}
                          onAttributeDelete={
                            ({ id }) => Modal.confirm({
                              title: t('reduxComponents.dsdDetail.component.deleteConfirmModal.title', { id }),
                              onOk() {
                                onAttributeDelete(id);
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                          onCodelistDetail={codelistTriplet => onCodelistDetailEdit(codelistTriplet, defaultItemsViewMode)}
                          onConceptDetail={codelistTriplet => onConceptSchemeDetailEdit(codelistTriplet, defaultItemsViewMode)}
                          onConceptSchemeDetail={conceptSchemeTriplet => onConceptSchemeDetailEdit(conceptSchemeTriplet, defaultItemsViewMode)}
                          onPrimaryMeasureCodelistSelect={onCodelistsForSelectorShow}
                          onPrimaryMeasureConceptSelect={onConceptSchemesForSelectorShow}
                        />
                        <DsdsDimensionDetail
                          userHasPermissionsToEdit={userHasPermissionsToEdit && !isEditDisabled}
                          instanceState={instanceState}
                          instancePrefix={instancePrefix}
                        />
                        <DsdsGroupDetail
                          userHasPermissionsToEdit={userHasPermissionsToEdit && !isEditDisabled}
                          instanceState={instanceState}
                          instancePrefix={instancePrefix}
                        />
                        <DsdsAttributeDetail
                          userHasPermissionsToEdit={userHasPermissionsToEdit && !isEditDisabled}
                          instanceState={instanceState}
                          instancePrefix={instancePrefix}
                        />
                        <DsdsConceptSelector instanceState={instanceState}
                          instancePrefix={instancePrefix}
                          onDetailShow={conceptSchemeTriplet => {
                            onConceptSchemeDetailEdit(conceptSchemeTriplet, defaultItemsViewMode)
                          }
                          } />
                        <DsdsCodelistSelector instanceState={instanceState}
                          instancePrefix={instancePrefix}
                          onDetailShow={codelistTriplet => {
                            onCodelistDetailEdit(codelistTriplet, defaultItemsViewMode)
                          }
                          } />
                        <DsdsConceptSchemeSelector instanceState={instanceState}
                          instancePrefix={instancePrefix}
                          onDetailShow={conceptSchemeTriplet => {
                            onConceptSchemeDetailEdit(conceptSchemeTriplet, defaultItemsViewMode)
                          }
                          } />
                        <DsdsNotDisplayedCodesSelector instanceState={instanceState}
                          instancePrefix={instancePrefix} />
                        <DsdsDefaultCodesSelector instanceState={instanceState}
                          instancePrefix={instancePrefix} />
                        <DsdsHierarchicalCodelistSelector instanceState={instanceState}
                          instancePrefix={instancePrefix} />
                        <ReduxCodelistDetailModal
                          instancePrefix={instancePrefix + DSD_DETAIL_CODELIST_DETAIL_PREFIX}
                          instanceState={codelistDetail}
                        />
                        <ReduxConceptSchemeDetailModal
                          instancePrefix={instancePrefix + DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX}
                          instanceState={conceptSchemeDetail}
                        />
                      </EnhancedModal>
                    </Call>
                  </Call>
                )
              }}
            </DataLanguageConsumer>
          </Call>
        </Call>
      </Call>
      <EnhancedModal
        visible={downloadDsdTriplets !== null && downloadDsdTriplets !== undefined}
        onCancel={onDownloadHide}
        footer={
          <div>
            <Button onClick={onDownloadHide}>
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              onClick={
                () => onDownloadSubmit(downloadDsdTriplets, downloadDsdParams, downloadDsdLang)
              }
              type="primary"
              disabled={downloadDsdParams && downloadDsdParams.format === null}
            >
              {t('commons.buttons.download.title')}
            </Button>
          </div>
        }
        width={MODAL_WIDTH_SM}
        title={
          downloadDsdTriplets && downloadDsdTriplets.length > 1
            ? t('scenes.metaManager.commons.modals.download.titleMulti')
            : t('scenes.metaManager.commons.modals.download.title', {
              triplet: downloadDsdTriplets
                ? getStringFromArtefactTriplet(downloadDsdTriplets[0])
                : ""
            })
        }>
        <ArtefactDownloadForm
          downloadArtefactForm={downloadDsdParams}
          onChange={onDownloadChange}
          options={getArtefactDownloadOptions(
            t,
            (downloadDsdTriplets && downloadDsdTriplets.length > 1)
              ? ARTEFACT_TYPE_MULTIPLE
              : ARTEFACT_TYPE_DSD
          )}
          langs={dataLanguages}
          hasReferences
        />
      </EnhancedModal>
      <EnhancedModal
        visible={cloneDestTriplet !== null}
        width={MODAL_WIDTH_MD}
        title={t('commons.artefact.modals.clone.title')}
        onCancel={onCloneHide}
        footer={
          <div>
            <Button onClick={onCloneHide}>
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              onClick={() => {
                if (!isCloneDestTripletValid(cloneDestTriplet)) {
                  Modal.warning({
                    title: t('commons.alerts.invalidForm.title'),
                    content: t('commons.alerts.invalidForm.content')
                  });
                } else {
                  onCloneSubmit(cloneDestTriplet, dsd, nodes.find(node => node.general.id === nodeId).annotations);
                }
              }}
              type="primary"
              disabled={(dsd != null && dsd.hasOwnProperty('isStructure20'))}
            >
              {t('commons.artefact.modals.clone.buttons.submit.title')}
            </Button>
          </div>
        }
      >
        <ArtefactCloneForm
          agencies={permittedAgencies}
          srcArtefact={dsd}
          destTriplet={cloneDestTriplet}
          onChange={onCloneChange}
        />
      </EnhancedModal>
      <EnhancedModal
        visible={dsdExportSourceTriplet !== null}
        title={t('commons.artefact.modals.export.title')}
        width={MODAL_WIDTH_MD}
        onCancel={onExportHide}
        footer={
          <div>
            <Button onClick={onExportHide}>{t('commons.buttons.close.title')}</Button>
            <Button
              type="primary"
              onClick={() => {
                if (isExportDestinationValid(dsdExportDestination)) {
                  onExportSubmit(dsdExportSourceTriplet, dsdExportDestination)
                } else {
                  Modal.warning({
                    title: t('commons.alerts.invalidForm.title'),
                    content: t('commons.alerts.invalidForm.content')
                  });
                }
              }}
            >
              {t('commons.artefact.modals.export.buttons.submit.title')}
            </Button>
          </div>
        }
      >
        <ArtefactExportForm
          type='datastructure'
          agencies={allAgencies}
          sourceTriplet={dsdExportSourceTriplet}
          destination={dsdExportDestination}
          onChange={onExportChange}
          withReferences
        />
      </EnhancedModal>
      <EnhancedModal
        visible={dsdExportReport !== null}
        title={t('commons.artefact.modals.exportReport.title')}
        width={MODAL_WIDTH_MD}
        onCancel={onExportReportHide}
        footer={<Button onClick={onExportReportHide}>{t('commons.buttons.close.title')}</Button>}
      >
        <ArtefactExportReport
          report={dsdExportReport}
        />
      </EnhancedModal>
    </Fragment>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(ReduxDsdDetailModal);
